import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

export default function Modal({ isOpen, title, onClose, children, footer }) {
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }
        const onKeyDown = (ev) => {
            if (ev.key === 'Escape' && onClose) {
                onClose();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div className="Modal-backdrop" onMouseDown={onClose}>
            <div
                className="Modal"
                role="dialog"
                aria-modal="true"
                aria-label={title}
                onMouseDown={(ev) => ev.stopPropagation()}
            >
                <div className="Modal-header">
                    <h2 className="Modal-title">{title}</h2>
                    <button type="button" className="Modal-close sm" onClick={onClose} aria-label="Fermer">✕</button>
                </div>
                <div className="Modal-content">{children}</div>
                {footer && <div className="Modal-footer">{footer}</div>}
            </div>
        </div>,
        document.body
    );
}
